export default function NumberInput({
  name,
  label,
  data,
  setData,
  labelColor,
  borderColor,
}) {
  return (
    <div>
      <label
        htmlFor={name}
        className={`${labelColor} block text-sm font-medium text-brandText`}
      >
        {label}
      </label>
      <div className='mt-1'>
        <input
          type='number'
          pattern='[0-9]*'
          name={name}
          id={name}
          min={0}
          onChange={(e) => {
            setData(e.target.value);
          }}
          value={data}
          className={`${borderColor} block w-full rounded-md border-gray-300 text-brandText shadow-sm focus:border-brandPrimary focus:ring-brandPrimary sm:text-sm`}
        />
      </div>
    </div>
  );
}
